let numFetchAttempts = 0;
const maxFetchAttempts = 2;

export default {
  async fetchContainer({ commit, dispatch }) {
    try {
      numFetchAttempts += 1;

      const response = await fetch("/digibord/data.json");

      if ([403, 404].includes(response.status)) {
        window.location.href = "/inloggen-aub";
        return;
      }

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const data = await response.json();

      if (data) {
        commit("setContainer", data);
      } else if (numFetchAttempts < maxFetchAttempts) {
        await dispatch("fetchContainer");
      }
    } catch (error) {
      if (numFetchAttempts < maxFetchAttempts) {
        await dispatch("fetchContainer");
      }

      // TODO: Else: Display error, allow to trigger retry.
    }
  },
};
